export const ADD_NEW_QUESTION = "ADD_NEW_QUESTION"
export const UPDATE_TAB_SETTING_SURVEY = "UPDATE_TAB_SETTING_SURVEY"
export const CLEAR_CREATE_QUESTION_REQUEST = "CLEAR_CREATE_QUESTION_REQUEST"
export const GET_SURVEY_CODE = "GET_SURVEY_CODE"
export const GET_SURVEY_DATA = "GET_SURVEY_DATA"
export const UPDATE_SURVEY_REQUEST = "UPDATE_SURVEY_REQUEST"
export const UPDATE_LOADING_QUESTION = "UPDATE_LOADING_QUESTION"